"use strict";

import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import * as Constants from "../../utilities/Constants";
import UrlHelper from "../../utilities/UrlHelper";
import UsersUtility from "newApp/utilities/UsersUtility";

import ProductsDropDown from './common/ProductsDropDown.jsx';

// components
import UserTable from "./UserTable";
import CreateUserDialog from "./CreateUserDialog";
import EditUserDialog from "./EditUserDialog";

import OrganizationProductsBar from "../common/OrganizationProductsBar";
import CheckBox from "../../controls/CheckBox.jsx";
import SearchWidget from "../common/SearchWidget";
import { getOrganizationById } from "../../actions/OrganizationActions";
import { getRolesProductById } from "../../actions/ProductActions";
import { getUsersByOrgId } from "../../actions/UsersActions";
import User from "../../entities/User";
import Organization from "../../entities/Organization";
import UserCreatedSuccessfullyDialog from "./UserCreatedSuccessfullyDialog.jsx";
import Actions from "../../actions/PersonnelActions";
import UserValidationObject from "../../entities/UserValidationObject";
import ValidationHelper from "../../utilities/ValidationHelper";
import { loadSsoSettingsById } from "newApp/actions/OrganizationActions";
import AuthenticationType from "newApp/configurations/AuthenticationType";


export class Container extends Component {
    constructor (props) {
        super(props);

        this.state = {
            showCreateUserDialog: false,
            showEditUserDialog: false,
            selectedProducts: [],
            showAllPersonnel: false,
            searchString: null,
            pageState: 0,
            showUserCreatedSuccessfullyDialog: false,
            selectedUser: {},
            validationResult: new UserValidationObject()
        };

        if (UrlHelper.getProductNameFromUrl(false) !== Constants.ORGANIZATION_PRODUCT_VERIFORM) {
            this.state.selectedProducts.push(Constants.ORGANIZATION_PRODUCT_SENTRI7);
            if (TeamName === Constants.ORGANIZATION_TEAM_PHARMACY) {
                this.state.selectedProducts.push(Constants.ORGANIZATION_PRODUCT_QUANTIFI);
            }
        }
        else {
            this.state.selectedProducts.push(Constants.ORGANIZATION_PRODUCT_VERIFORM);
        }

        this.onProductSelect = this.onProductSelect.bind(this);
        this.setActiveOnly = this.setActiveOnly.bind(this);
        this.setSearchString = this.setSearchString.bind(this);

        this.filterUsers = this.filterUsers.bind(this);
        this.hideCreateUserDialog = this.hideCreateUserDialog.bind(this);
        this.hideEditUserDialog = this.hideEditUserDialog.bind(this);
        this.showNewUserDialog = this.showNewUserDialog.bind(this);
        this.showCreatedUserSuccessfully = this.showCreatedUserSuccessfully.bind(this);
        this.hideUserCreatedSuccessfully = this.hideUserCreatedSuccessfully.bind(this);
        this.onUserSelect = this.onUserSelect.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
        this.createUser = this.createUser.bind(this);
        this.editUser = this.editUser.bind(this);
        this.hideErrorSummary = this.hideErrorSummary.bind(this);
        this.filterLinkedToVirtualUser = this.filterLinkedToVirtualUser.bind(this);
        this.hasToHideUsersLinkedToVirtualUser = this.hasToHideUsersLinkedToVirtualUser.bind(this);
    }

    createDefaultUser () {
        const user = new User();
        user.createDefault(this.props.organization, this.props.productRoles);
        return user;
    }

    componentDidMount () {
        import("./_styles.scss");
        this.props.getOrganizationById(this.props.organizationId);
        this.props.getUsersByOrgId(this.props.organizationId);
        this.props.getSsoOrganizationSettings(this.props.organizationId);
    }

    render () {
        const filteredUsers = this.filterUsers(this.props.users);
        const hideNewUserButton = !this.hasToHideUsersLinkedToVirtualUser();

        return (
            <div>
                <div className="row">
                    <OrganizationProductsBar products={this.props.products}/>
                </div>
                <div className="row col-md-14">
                    <div className="col-md-3" style={{ paddingRight: "0px" }}>
                        <h2>Personnel</h2>
                    </div>
                    <div className="col-md-4 search-container react-bs-table-search-form">
                        <SearchWidget placeholder="Search Personnel (Name or Email)"
                            onChange={searchText => this.setSearchString(searchText)}
                            onClear={() => this.setSearchString(null)}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-5">
                        <div id="productsFilter">
                            <ProductsDropDown
                                selectedProducts={this.state.selectedProducts}
                                availibleProducts={this.props.products.map(product => product.productName)}
                                onChange={(val) => this.onProductSelect(val)}/>
                        </div>
                    </div>

                    <PersonnelFilter showAll={this.state.showAllPersonnel} onClick={this.setActiveOnly}/>

                    {hideNewUserButton &&
                    <NewUserButton onClick={this.showNewUserDialog}/>
                    }
                </div>

                <div className="row">
                    <UserTable
                        onSelect={(user) => this.onUserSelect(user)}
                        users={filteredUsers}
                        selectedProducts={this.state.selectedProducts}
                    />
                </div>
                <div>
                    <div style={{ marginTop: "50px" }}>
                        <span style={{ marginRight: "20px" }} className="glyphicon glyphicon-warning-sign"/>
                        Password reset needed
                    </div>
                    <div style={{ marginTop: "10px" }}>
                        <span style={{ marginRight: "20px" }} className="glyphicon glyphicon-lock"/>
                        Locked out of application
                    </div>
                </div>

                <CreateUserDialog id="editUserDialog"
                    show={this.state.showCreateUserDialog}
                    onCancel={this.hideCreateUserDialog}
                    onSave={this.createUser}
                    validationResult={this.state.validationResult}
                    hideErrorSummary = {this.hideErrorSummary}
                />

                <EditUserDialog id="editUserDialog"
                    show={this.state.showEditUserDialog}
                    onCancel={this.hideEditUserDialog}
                    onSave={this.editUser}
                    validationResult={this.state.validationResult}
                    resetPassword={this.resetPassword}
                    hideErrorSummary = {this.hideErrorSummary}
                />

                <UserCreatedSuccessfullyDialog id="userCreatedSuccessfullyDialog"
                    show={this.state.showUserCreatedSuccessfullyDialog}
                    onOk={this.hideUserCreatedSuccessfully}
                    user={this.state.selectedUser}
                />
            </div>
        );
    }

    hideErrorSummary() {
        const result = this.state.validationResult.createCopy();
        result.show = false;

        this.setState({ validationResult: result });
    }

    _validateUserInfo(result) {
        return result.firstName.isValid
            && result.lastName.isValid
            && result.email.isValid
            && result.phone.isValid
            && result.userProducts.isValid;
    }

    checkUserIsValid () {
        const result = this.state.validationResult.createCopy();
        const user = this.props.user;
        if (ValidationHelper.isNullOrEmpty(user.firstName)) {
            result.firstName.isValid = false;
        }

        if (ValidationHelper.isNullOrEmpty(user.lastName)) {
            result.lastName.isValid = false;
        }

        if (!ValidationHelper.isNullOrEmpty(user.email)) {
            result.email.isValid = ValidationHelper.isValidEmailFormat(this.props.user.email);
        }

        if (!ValidationHelper.isNullOrEmpty(user.phone)) {
            result.phone.isValid = ValidationHelper.isValidPhoneNumber(this.props.user.phone);
        }

        result.userProducts.isValid = this.props.user.userProducts.length > 0;
        result.isValid = this._validateUserInfo(result);
        result.show = !result.isValid;

        this.setState({ validationResult: result });
        return result.isValid;
    }

    createUser() {
        var userIsValid = this.checkUserIsValid();
        const excludeInactive = false;
        const filterByProductId = null;
        const filterByTeamId = null;

        if (userIsValid) {
            this.props.createUser(this.props.user, this.props.organization).then((createdUser) => {
                this.hideCreateUserDialog();
                this.showCreatedUserSuccessfully(createdUser);
                this.props.getUsersByOrgId(this.props.organizationId, excludeInactive, filterByProductId, filterByTeamId);
            });
        }
    }

    editUser () {
        var userIsValid = this.checkUserIsValid();
        const user = this.props.user;
        const productRoles = this.props.productRoles;
        const excludeInactive = false;
        const filterByProductId = null;
        const filterByTeamId = null;

        if (userIsValid) {
            var userPrevState = this.props.users.find(u => u.id === user.id);
            this.props.saveUser(this.props.user, userPrevState, this.props.organization, productRoles).finally(() => {
                this.hideEditUserDialog();
                this.props.getUsersByOrgId(this.props.organizationId, excludeInactive, filterByProductId, filterByTeamId);
            });
        }
    }

    showCreatedUserSuccessfully (user) {
        this.setState({ showUserCreatedSuccessfullyDialog: true, selectedUser: user });
    }

    hideUserCreatedSuccessfully() {
        this.setState({ showUserCreatedSuccessfullyDialog: false });
    }

    setSearchString (value) {
        this.setState({ searchString: value });
    }

    onProductSelect (value) {
        this.setState({ selectedProducts: value });
    }

    setActiveOnly () {
        this.setState({ showAllPersonnel: !this.state.showAllPersonnel });
    }

    filterUsers (users) {
        // filter by active
        let filteredUsers = users;

        if (!this.state.showAllPersonnel) {
            filteredUsers = UsersUtility.filterByActivity(users);
        }

        filteredUsers = this.filterLinkedToVirtualUser(filteredUsers);
        filteredUsers = UsersUtility.filterByNameOrEmail(filteredUsers, this.state.searchString);
        return UsersUtility.filterUsersByProducts(filteredUsers, this.state.selectedProducts);
    }

    filterLinkedToVirtualUser (users) {
        if (!this.hasToHideUsersLinkedToVirtualUser()) {
            return users;
        }

        return UsersUtility.filterByIsUserLinkedToVU(users);
    }

    hasToHideUsersLinkedToVirtualUser () {
        if (this.props.ssoSettings == null) {
            return false;
        } else if (this.props.ssoSettings.authenticationType !== AuthenticationType.Sso.value &&
                this.props.ssoSettings.authenticationType !== AuthenticationType.Password.value) {
            return false;
        }

        return true;
    }

    onUserSelect (user) {
        var usr = user.createCopy();
        this.props.setUser(usr);
        this.setState({ showEditUserDialog: true });
    }

    showNewUserDialog () {
        const user = this.createDefaultUser();
        this.props.setUser(user);
        this.setState({ showCreateUserDialog: true, newUser: user });
    }

    hideEditUserDialog () {
        this.setState({ showEditUserDialog: false, validationResult: new UserValidationObject() });
    }

    hideCreateUserDialog () {
        this.setState({ showCreateUserDialog: false, validationResult: new UserValidationObject() });
    }

    resetPassword () {
        this.props.resetPassword(this.props.user.id);
    }
}

const PersonnelFilter = ({ showAll, onClick }) => (
    <div className="col-md-3" id="CheckAll">
        <CheckBox id="cbShowAll" checked={showAll} onChange={onClick} title="Include Inactive Personnel" />
    </div>
);

const NewUserButton = ({ onClick }) => (
    <button className="btn btn-primary btn-md push-button"
        id="newUser"
        onClick={onClick}
        tabIndex="-1">New</button>
);

Container.defaultProps = {
    users: [],
    getSsoOrganizationSettings: () => {}
};

Container.propTypes = {
    organization: PropTypes.instanceOf(Organization),
    organizationId: PropTypes.number.isRequired,
    getOrganizationById: PropTypes.func.isRequired,
    getUsersByOrgId: PropTypes.func.isRequired,
    getSsoOrganizationSettings: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    products: state.personnelState.products,
    organization: state.organizationState.organization,
    users: state.personnelState.users,
    user: state.personnelState.user,
    productRoles: state.personnelState.productRoles,
    ssoSettings: state.settingsState.ssoSettings
});

const mapDispatchToProps = (dispatch) => {
    return ({
        getOrganizationById: (orgId) => dispatch(getOrganizationById(orgId)).then((organization) => {
            organization.products.forEach(product => {
                dispatch(getRolesProductById(product.productId, product.productName));
            });
        }),
        getUsersByOrgId: (orgId, excludeInactive, filterByProductId, filterByTeamId) => {
            return dispatch(getUsersByOrgId(orgId, excludeInactive, filterByProductId, filterByTeamId));
        },
        setUser: (user) => dispatch(Actions.setUser(user)),
        resetPassword: (userId) => dispatch(Actions.resetPassword(userId)),
        saveUser: (user, prevUserState, organization, roles) => dispatch(Actions.saveUser(user, prevUserState, organization, roles)),
        createUser: (user, organization) => dispatch(Actions.createUser(user, organization)),
        getSsoOrganizationSettings: (organizationId) => dispatch(loadSsoSettingsById(organizationId))
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);

